import React from 'react';
import axios from 'axios';
import {Boton, Accion} from '../../comun/Index';
import Nuevo from './Nuevo';

class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={ }
  }


  render(){
    const {expandir} = this.state;
    const {defensorias} = this.props;
    return(
      <div className="Lista">
        {defensorias.map((item, index) => {
          return(
            <div
              key={index}
              className="Item"
              style={{backgroundColor:index%2===1?'#e3e3e3':'#f0f0f0'}}
            >
              <div className="Detalles">
                <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                  {item.localidad} 
                </div>
                <div className="Acciones">
                  <Accion
                    icono="edit"
                    ayuda="Editar"
                    backgroundColor="#00a5e5"
                    disabled={true}
                    onClick={() => this.props.editar(index)}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    );
  }
}

const getLocalidades = function(){
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + '/localidades/listar/')
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve(res.data.localidades)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

const getDefensorias = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/emisores/todos/defensorias'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.defensorias)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

export default class Usuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      defensorias:[],
      localidades:[],
      showModal:false,
      datosModal:{}
    }
  }

  componentDidMount(){
    getLocalidades()
    .then((localidades) => {
      this.setState({localidades})
      this.actualizar();
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }



  async actualizar(){
    getDefensorias()
    .then((defensorias) => this.setState({defensorias}))
    .catch((error) => {
      alert("Ocurrió un error");
      console.log(error)
    })
  }

  nuevo(){
    this.setState({datosModal:{},showModal:true});
  }

  // editar(index){
  //   this.setState({datosModal:this.state.usuarios[index]});
  //   this.setState({showModal:true});
  // }

  guardar(datos){
    const url = localStorage.getItem('apiUrl') + '/emisores/admin/defensoria';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.setState({showModal:false,datosModal:{}});
        this.actualizar();
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }

  render(){
    const {showModal, datosModal, defensorias, localidades} = this.state;
    return(
      <div className="TramitesTodo">
        {showModal &&
          <Nuevo
            localidades={localidades}
            salir={() => {window.scrollTo(0,0);this.setState({showModal:false,datosModal:{}})}}
            guardar={(datos) => {window.scrollTo(0,0);this.guardar(datos)}}
          />
        }
        <h3>Defensorias</h3>
        <Listado
          defensorias={defensorias}
          editar={(index) => {window.scrollTo(0,0);this.editar(index)}}
        />
        <Boton
          backgroundColor="#00a5e5"
          titulo="Nuevo"
          onClick={() => {window.scrollTo(0,0);this.nuevo()}}
        />
      </div>
    );
  }
}
